// customization:
// - added function to run script

import React, { useEffect, useRef } from 'react';
import cx from 'classnames';
import { ConditionalEmbed } from 'volto-gdpr-privacy';

const View = ({ data }) => {
  const root = useRef(null);
  const script = useRef('');
  const style = useRef('');

  useEffect(() => {
    const container = root.current;
    if (!container) return;

    // check all script tags
    const scriptTags = container.querySelectorAll('script');

    // for each old script create a new element
    scriptTags.forEach((oldScript) => {
      const newScript = document.createElement('script');

      // assign the attributes to new script
      [...oldScript.attributes].forEach((attr) =>
        newScript.setAttribute(attr.name, attr.value),
      );

      newScript.textContent = oldScript.textContent;

      // substitute old script with new one
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });

    // apply style elements
    if (root.current && data.styles) {
      if (style.current) {
        root.current.removeChild(style.current);
      }
      const styleEl = document.createElement('style');
      styleEl.innerHTML = `@import url("${data.styles}")`;
      style.current = styleEl;
      root.current.appendChild(styleEl);
    }
  }, [data]);

  return (
    <ConditionalEmbed code={data.html}>
      <div
        className={cx('block html script-embed py-5', {
          // 'full-width': data.showFullWidth,
          // 'bg-light': data.bgColor,
        })}
        ref={root}
      >
        <div className="container px-4 ">
          <div dangerouslySetInnerHTML={{ __html: data.html }} />
        </div>
      </div>
    </ConditionalEmbed>
  );
};

export default View;
